const NAMESPACE = "clientCredentialExpirationOptions";

const KEYS = {
    oneWeek: "oneWeek",
    oneMonth: "oneMonth",
    oneYear: "oneYear",
    fiveYears: "fiveYears",
    indefinite: "indefinite"
};

const MESSAGES = {
    [KEYS.oneWeek]: { value: "One week", comment: "Label for one week dropdown expiration option" },
    [KEYS.oneMonth]: { value: "One month", comment: "Label for one month dropdown expiration option" },
    [KEYS.oneYear]: { value: "One year", comment: "Label for one year dropdown expiration option" },
    [KEYS.fiveYears]: { value: "Five years", comment: "Label for five years dropdown expiration option" },
    [KEYS.indefinite]: { value: "Never expire", comment: "Label for indefinite dropdown expiration option" }
};

export { KEYS, NAMESPACE, MESSAGES };
